import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import React from 'react';
import { toast } from 'react-hot-toast';

import SALES_USERS from '../../api/ressources/SellerApp/salesUsers';

export const getSalesUsers = createAsyncThunk(
  '/salesUsers',
  async (saleId) => {
    const response = await SALES_USERS.getSalesUsers(saleId);
    return response.data
  }
);

export const submitSalesUser = createAsyncThunk(
  '/submitSalesUser',
  async ({ saleId, salesUserId = null, params }, { rejectWithValue }) => {
    let response;

    try {
      if (salesUserId) {
        response = await SALES_USERS.updateSalesUser(saleId, salesUserId, params)
      } else {
        response = await SALES_USERS.createSalesUser(saleId, params)
      }
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const removeSalesUser = createAsyncThunk(
  '/removeSalesUser',
  async ({ saleId, salesUserId }, { rejectWithValue }) => {
    try {
      const response = await SALES_USERS.removeSalesUser(saleId, salesUserId)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  displaySalesUsersModal: false,
  signatories: [],
  saleContacts: [],
  salesUser: null,
  isSubmitting: false,
  salesUserToRemove: null,
  isRemoving: false,
  errors: {}
};

export const salesUsersSlice = createSlice({
  name: 'salesUser',
  initialState,
  reducers: {
    resetSalesUsers: () => initialState,
    updateSalesUser: (state, { payload }) => {
      state.salesUser = payload
      if (!state.saleUser) state.errors = initialState.errors
    },
    updateDisplaySalesUsersModal: (state, { payload }) => {
      state.displaySalesUsersModal = payload
    },
    updateSalesUserToRemove: (state, { payload }) => {
      state.salesUserToRemove = payload
    },
    updateErrors: (state, { payload }) => {
      state.errors = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSalesUsers.fulfilled, (state, { payload }) => {      
      state.signatories = payload.results.filter((saleUser) => saleUser.signatory);
      state.saleContacts = payload.results.filter((saleUser) => !saleUser.signatory);
    })
    builder.addCase(submitSalesUser.pending, (state) => {
      state.isSubmitting = true
    })
    builder.addCase(submitSalesUser.fulfilled, (state, { payload }) => {
      state.signatories = payload.results.filter((saleUser) => saleUser.signatory);
      state.saleContacts = payload.results.filter((saleUser) => !saleUser.signatory);
      state.salesUser = initialState.salesUser
      state.isSubmitting = initialState.isSubmitting
      toast.success('Le contact a bien été enregistré', { duration: 3000 })
    })
    builder.addCase(submitSalesUser.rejected, (state, { payload }) => {
      state.errors = payload.error.message;
      state.isSubmitting = false
    })
    builder.addCase(removeSalesUser.pending, (state) => {
      state.isRemoving = true
    })
    builder.addCase(removeSalesUser.fulfilled, (state, { payload }) => {
      state.signatories = payload.results.filter((saleUser) => saleUser.signatory);
      state.saleContacts = payload.results.filter((saleUser) => !saleUser.signatory);
      state.isRemoving = initialState.isRemoving
      state.salesUserToRemove = initialState.salesUserToRemove
      toast.success('Le contact a bien été retiré', { duration: 3000 })
    })
    builder.addCase(removeSalesUser.rejected, (state, { payload }) => {
      toast.error("Une erreur s'est produite, veuillez contacter votre agent", { duration: 3000 })
      state.isRemoving = initialState.isRemoving
    })
  },
})

export const { resetSalesUsers, updateDisplaySalesUsersModal, updateSalesUser, updateSalesUserToRemove, updateErrors } = salesUsersSlice.actions;

export default salesUsersSlice.reducer;
